const faXmark = {
  prefix: 'fal',
  iconName: 'xmark',
  icon: [
    384,
    512,
    [128473, 10005, 10006, 10060, 215, 'close', 'multiply', 'remove', 'times'],
    'f00d',
    'M379.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 27.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 4.7 420.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 356.7 443.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 379.3 91.3z',
  ],
};
export default faXmark;
